import React from 'react';
import RipplrLogo from 'assets/ripplr-logo.svg';
import Cartoon from 'assets/cartoon.png';
import { Box, Image, Flex, Text } from 'atoms';
import { LoginForm } from 'forms';
import { version } from '../../package.json';

export default function Login() {
	return (
		<Flex
			flexDirection="column"
			alignItems="center"
			bg={process?.env?.REACT_APP_ENV !== 'production' ? 'gold' : ''}
		>
			<Box py="1rem">
				<Image src={RipplrLogo} alt="Ripplr Logo" height={27} width={116} />
			</Box>
			<Box textAlign="center">
				<Text fontSize="16px" pt="1rem">
					Welcome to
				</Text>
				<Text
					id="login-page-title"
					fontSize="16px"
					fontWeight="700"
					pt="1rem"
					maxWidth="150px"
					lineHeight="22px"
				>
					Sales Collection Module
				</Text>
				{process?.env?.NODE_ENV === 'development' && (
					<>
						<hr />
						<Text fontSize="12px" lineHeight="16px">
							<div>Vigneshwaran : 9367518142</div>
							<div>Praveen : 9663740084</div>
							<div>Arjun : 8015495873</div>
							<div>additionalresource@ripplr.in</div>
							<div>r!pp1r@123</div>
						</Text>
						<hr />
					</>
				)}
			</Box>
			<Box width="220px">
				<LoginForm />
			</Box>
			<Box py="3rem">
				<Image src={Cartoon} alt="Ripplr Cartoon" width={200} />
			</Box>
			{process?.env?.REACT_APP_ENV !== 'production' && (
				<Text
					textTransform="capitalize"
					fontSize="10px"
					textAlign="center"
					px=".4rem"
					py="1rem"
					lineHeight="16px"
				>
					{process.env.NODE_ENV} | {process?.env?.REACT_APP_ENV} | Version {version} |{' '}
					{window.location.href} | BuildCount - 73
				</Text>
			)}
		</Flex>
	);
}
